/* eslint-disable */
import React, { useCallback, useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { get, forEach } from 'lodash'
import cn from 'classnames'
import moment from 'moment'

import Button from '../components/Button'
import styles from './DebugInfo.module.scss'
import { Box, Typography } from '@material-ui/core'

import PeripheralBridge from '../utils/peripheralBridge'

import PorticoRemote from '../remote/porticoRemote'

import { onBuildInfoReceived } from '../actions/peripheral'
import { purgeAllOrders } from '../actions/order'
import { fetchPrinters } from '../actions/printer'

import { getErrorInfo } from '../selectors/appState'
import { getCurrentConfiguration, getDeviceAllowList, getIsPrintController, getControlledPrinterUuids } from '../selectors/config'
import { getCurrentMenu } from '../selectors/menus'
import { getBuildInfo, getTerminalInfo, getPaymentType, PAX_PAYMENT_TYPE, getSafFullResponse } from '../selectors/peripheral'
import { getPrinters } from '../selectors/printer'
import { getLatestOrderUuid } from '../selectors/order'

import { networkSignalSpeed } from '../utils/networkConnected'
import { ToastManager } from '../utils/toastManager'
import { SUCCESS, defaultAllowList, updateAllowList, isSuccess, isFailed } from '../utils/allowList'

import useSafMode from '../hooks/useSafMode'
import useGetIsMobileScreen from '../hooks/useGetIsMobileScreen'

import { getAndroidSDKVersion } from '../VNAndroidSDK/Selectors'
import { bridge_resetDevice } from '../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import ConfirmModalV2 from './ConfirmModalV2'
import VNConcessionsNavBar from './VNConcessionsNavBar'
import SegmentedControlV2 from './segmentedControl/SegmentedControl'
import VNBlueSwitch from './VNBlueSwitch'
import MutationApi from '../remote/mutationApi'
import { getCashEnabled } from '../selectors/revenueCenter'
import { SHIFT4_BLUE } from '../styles/constants'
import { setManagerApprovalPrompt } from '../VNManagerApproval/ActionCreators'
import useDeviceIdentifiers from '../VNUtil/hooks/useDeviceIdentifiers'

import { isSDKCompatible } from '../VNAndroidSDK/Utils'
import { bridge_getBuildInfo } from '../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'

const DEBUG_TABS = {
  HARDWARE: 'hardware',
  SOFTWARE: 'software',
  NETWORK: 'network',
  PRINTING: 'printing',
}

const misMatchElement = (configuredValue) => {
  return <div>{`${configuredValue}`}</div>
}

const DebugInfo = ({
  presetToggle,
  config,
  buildInfo,
  onBuildInfoReceived,
  secondaryDeviceId,
  className,
  deviceType,
  errorInfo,
  safFullResponse,
  onClickClearAllOrders,
  loadPrinters,
}) => {
  const dispatch = useDispatch()
  const classNames = cn(styles.debugInfo, className)

  const [terminalId, setTerminalId] = useState('loading...')
  const [storeId, setStoreId] = useState('loading...')
  const [esKey, setESKey] = useState('loading...')
  const [serviceURL, setServiceURL] = useState('loading...')
  const [terminalIdMatches, setTerminalIdMatches] = useState(true)
  const [storeIdMatches, setStoreIdMatches] = useState(true)
  const [esKeyMatches, setESKeyMatches] = useState(true)
  const [serviceURLMatches, setServiceURLMatches] = useState(true)
  const [configsMatch, setConfigsMatch] = useState(true)
  const isMobileViewPort = useGetIsMobileScreen()
  const menu = useSelector(getCurrentMenu)
  const { getIdentifiers, isSummit } = useDeviceIdentifiers()

  // for switch between hardware and software view
  const [toggle, setToggle] = useState(presetToggle)

  const [refreshTimestamp, setRefreshTimestamp] = useState(new Date().toString())
  const [signalSpeed, setSignalSpeed] = useState(0)
  const [signalSpeedDisplay, setSignalSpeedDisplay] = useState('Offline')
  const [initiateSafBridgeCommunication, updateSafMode, getSafModeFromBridge, { safMode }] = useSafMode()
  const [showClearOrdersModal, setShowClearOrdersModal] = useState(false)

  const fullNetworkAllowList = useSelector(getDeviceAllowList)

  const token = localStorage.getItem('accessToken')
  const tokenHeader = token !== null ? JSON.parse(window.atob(token.split('.')[0])) : undefined
  const tokenPayload = token !== null ? JSON.parse(window.atob(token.split('.')[1])) : undefined

  const isPrintController = useSelector(getIsPrintController)
  const controlledPrinterUuids = useSelector(getControlledPrinterUuids) || []
  const networkPrinters = useSelector(getPrinters)
  const latestOrderUuid = useSelector(getLatestOrderUuid)
  const cashEnabled = useSelector(getCashEnabled)
  const androidSDKVersion = useSelector(getAndroidSDKVersion)

  const [webSocketStatus, setWebsocketStatus] = useState('Unknown')
  const [webSocketConnectionTime, setWebsocketConnectionTime] = useState('Connection Untested')
  const deviceIdentifiers = getIdentifiers()
  const deviceId = deviceIdentifiers?.deviceId || 'unknown'
  const serialNumber = deviceIdentifiers?.serialNumber || 'unknown'

  const [networkAllowListStatuses, setNetworkAllowListStatuses] = useState({})
  const [printerListStatuses, setPrinterListStatuses] = useState({})

  const hypertextedPort = (port) => {
    return `http://${port}`
  }

  const buildNetworkAllowListComponent = () => {
    if (toggle !== DEBUG_TABS.NETWORK) return null

    if (toggle === DEBUG_TABS.NETWORK) {
      return Object.keys(networkAllowListStatuses).map((url, index) => {
        let style = styles.urlStatusConnecting
        if (isSuccess(networkAllowListStatuses, url)) {
          style = styles.urlStatusSuccess
        } else if (isFailed(networkAllowListStatuses, url)) {
          style = styles.urlStatusFailed
        }

        return (
          <div>
            <div className={styles.url}>{url}</div>
            <p className={style}>{networkAllowListStatuses[url]}</p>
          </div>
        )
      })
    }
  }

  const buildPrinterListComponent = () => {
    if (toggle !== DEBUG_TABS.PRINTING) return null

    return controlledPrinterUuids.map((uuid) => {
      const printer = networkPrinters.find((p) => p.uuid === uuid)
      if (!printer || !printer.port) return null

      const modifiedPort = hypertextedPort(printer.port)

      return (
        <div>
          <div className={styles.url}>
            {printer.name} / {printer.port}
          </div>
          {printerListStatuses[modifiedPort] == SUCCESS && (
            <p className={isSuccess(printerListStatuses, modifiedPort) ? styles.urlStatusSuccess : styles.urlStatusFailed}>
              {printerListStatuses[modifiedPort]}
            </p>
          )}
          <Button
            className={styles.testPrintButton}
            onClick={() => {
              runTestPrint(printer.uuid)
            }}
          >
            Test Print
          </Button>
        </div>
      )
    })
  }

  const [networkAllowListComponent, setNetworkAllowListComponent] = useState(buildNetworkAllowListComponent())
  const [printerListComponent, setPrinterListComponent] = useState(buildPrinterListComponent())

  const onClickClearOrders = () => {
    const onSuccess = () => {
      onClickClearAllOrders()
      ToastManager.success('Orders cleared.')
    }
    dispatch(setManagerApprovalPrompt({ onSuccess, buttonText: 'Clear Orders' }))
  }

  const onClickReregisterDevice = () => {
    const onSuccess = () => {
      bridge_resetDevice()
      ToastManager.success('Reregistered device.')
    }

    dispatch(setManagerApprovalPrompt({ onSuccess, buttonText: 'Reregister Device' }))
  }

  const onClickOpenCashDrawer = () => {
    const onSuccess = () => {
      const bridgeInstance = PeripheralBridge.getBridge()
      if (bridgeInstance) bridgeInstance.call('openDrawer')
    }

    dispatch(setManagerApprovalPrompt({ onSuccess, buttonText: 'Open Cash Drawer' }))
  }

  const handleOnSafToggle = () => {
    const onSuccess = () => {
      if (safMode !== 3) {
        updateSafMode(3)
      } else {
        updateSafMode(2)
      }
    }
    dispatch(setManagerApprovalPrompt({ onSuccess, buttonText: 'Change SAF Mode' }))
  }

  useEffect(() => {
    updateAllowList(
      networkAllowListStatuses,
      (url) => {
        setNetworkAllowListComponent(buildNetworkAllowListComponent())
      } /* successCallback */,
      (url) => {
        setNetworkAllowListComponent(buildNetworkAllowListComponent())
      } /* failureCallback */,
    )
  }, [networkAllowListStatuses])

  useEffect(() => {
    updateAllowList(
      printerListStatuses,
      (url) => {
        setPrinterListComponent(buildPrinterListComponent())
      } /* successCallback */,
      (url) => {
        setPrinterListComponent(buildPrinterListComponent())
      } /* failureCallback */,
    )
  }, [printerListStatuses])

  const updateWebsocketRetrievalTime = () => {
    const currentTime = moment()
    setWebsocketConnectionTime(currentTime.format('YYYY-MM-DD hh:mm:ss A'))
  }

  const fetchDeviceInfo = () => {
    PorticoRemote.getDeviceInfo(deviceIdentifiers)
      .then((res) => {
        updateWebsocketRetrievalTime()

        if (!res.data) {
          setWebsocketStatus('No Response')
          return
        }

        if (isSummit && !res.data.presence[`privatePrinter${serialNumber}`]) {
          setWebsocketStatus('Disconnected')
          return
        }

        if (!isSummit && !res.data.presence[`privatePrinter${deviceId}`]) {
          setWebsocketStatus('Disconnected')
          return
        }

        setWebsocketStatus('Good')
      })
      .catch((err) => {
        updateWebsocketRetrievalTime()
        setWebsocketStatus('Error')
      })
  }

  const runTestPrint = (printerUuid) => {
    if (!latestOrderUuid) {
      ToastManager.error('You need to have at least one order in memory to print.')
      return
    }

    if (!printerUuid) {
      ToastManager.error('Printer not found.')
      return
    }

    MutationApi.printOrder({ orderUuid: latestOrderUuid, printerUuids: [printerUuid] })
      .then(() => {
        ToastManager.success('Test print sent to printer.')
      })
      .catch(() => {
        ToastManager.error('Error sending test print.')
      })
  }

  const switchToNetworkToggle = () => {
    try {
      networkSignalSpeed(setSignalSpeed)
    } catch {
      setSignalSpeed(0)
    }

    const clearedAllowList = defaultAllowList(fullNetworkAllowList)
    setNetworkAllowListStatuses(clearedAllowList)
  }

  const switchToPrinterToggle = () => {
    fetchDeviceInfo()

    const defaultPrinterStatuses = networkPrinters.reduce((acc, printer) => {
      if (!printer.port || !controlledPrinterUuids.includes(printer.uuid)) {
        return acc
      }

      acc[hypertextedPort(printer.port)] = 'UNKNOWN'
      return acc
    }, {})

    setPrinterListStatuses(defaultPrinterStatuses)
  }

  useEffect(() => {
    if (toggle === DEBUG_TABS.NETWORK) {
      switchToNetworkToggle()
      return
    }

    setNetworkAllowListStatuses({})
    setPrinterListStatuses({})
  }, [toggle])

  useEffect(() => {
    if (toggle !== DEBUG_TABS.PRINTING) return

    switchToPrinterToggle()
  }, [networkPrinters])

  useEffect(() => {
    const matches = terminalIdMatches && storeIdMatches && esKeyMatches
    setConfigsMatch(matches)
  }, [terminalIdMatches, storeIdMatches, esKeyMatches])

  useEffect(() => {
    if (signalSpeed === 1) {
      setSignalSpeedDisplay('Very Slow')
    } else if (signalSpeed === 2) {
      setSignalSpeedDisplay('Slow')
    } else if (signalSpeed === 3) {
      setSignalSpeedDisplay('Fair')
    } else if (signalSpeed === 4) {
      setSignalSpeedDisplay('Good')
    }
  }, [signalSpeed])

  useEffect(() => {
    const configurationStatusResolver = (configuredValue, expectedValue, updateValidityMethod, updateValueMethod) => {
      if (configuredValue !== expectedValue) {
        updateValueMethod(misMatchElement(configuredValue))
      } else {
        updateValueMethod(expectedValue)
      }

      updateValidityMethod(configuredValue === expectedValue)
    }

    const bridgeInstance = PeripheralBridge.getBridge()
    if (!bridgeInstance) {
      configurationStatusResolver('unavailable', get(config, 'terminalId'), setTerminalIdMatches, setTerminalId)
      configurationStatusResolver('unavailable', get(config, 'storeId'), setStoreIdMatches, setStoreId)
      configurationStatusResolver('unavailable', get(config, 'esKey'), setESKeyMatches, setESKey)
      configurationStatusResolver('unavailable', get(config, 'url'), setServiceURLMatches, setServiceURL)

      return
    }

    bridge_getBuildInfo(androidSDKVersion)

    bridgeInstance?.callHandler('executeTerminalRequest', null)
    bridgeInstance?.callHandler('getConfig', null, (response) => {
      const configuredTerminalId = get(response, 'terminalID')
      const configuredStoreId = get(response, 'storeID')
      const configuredESKey = get(response, 'esKey')
      const configuredServiceURL = get(response, 'url')
      const resolverParams = [
        [configuredTerminalId, get(config, 'terminalId'), setTerminalIdMatches, setTerminalId],
        [configuredStoreId, get(config, 'storeId'), setStoreIdMatches, setStoreId],
        [configuredESKey, get(config, 'esKey'), setESKeyMatches, setESKey],
        [configuredServiceURL, get(config, 'url'), setServiceURLMatches, setServiceURL],
      ]

      forEach(resolverParams, (params) => configurationStatusResolver(...params))
    })
  }, [config, refreshTimestamp])

  const onChange = (newValue) => {
    if (newValue === DEBUG_TABS.PRINTING) {
      loadPrinters()
    }

    setToggle(newValue)
  }

  // Switch Selector
  let options = [
    {
      label: <span>Hardware</span>,
      value: DEBUG_TABS.HARDWARE,
      selectedBackgroundColor: SHIFT4_BLUE,
    },
    {
      label: <span>Software</span>,
      value: DEBUG_TABS.SOFTWARE,
      selectedBackgroundColor: SHIFT4_BLUE,
    },
    {
      label: <span>Network</span>,
      value: DEBUG_TABS.NETWORK,
      selectedBackgroundColor: SHIFT4_BLUE,
    },
  ]

  if (isPrintController) {
    options.push({
      label: <span>Printing</span>,
      value: DEBUG_TABS.PRINTING,
      selectedBackgroundColor: SHIFT4_BLUE,
    })
  }

  const screenSize = `${window.innerWidth} x ${window.innerHeight}`

  // temp
  const websocketInfo = {
    device_id: isSummit ? serialNumber : deviceId,
    organization_name: process.env.REACT_APP_ORG,
    app_type: null,
    device_name: null,
    locked_at: null,
    presence: null,
  }

  const onClickSpeedTest = () => {
    document.getElementById('externalWebsite').src = 'https://fast.com'
    document.getElementById('externalContent').style.display = 'block'
  }

  // This is for later. The pusher URI won't embed properly.
  // const onClickPusherTest = () => {
  //   document.getElementById('externalWebsite').src = 'https://test.pusher.com/?env=us2'
  //   document.getElementById('externalContent').style.display = 'block'
  // }

  const onClickExternalClose = () => {
    document.getElementById('externalContent').style.display = 'none'
    document.getElementById('externalWebsite').src = ''
  }

  let clearOrdersModal

  const clearOrdersSubtext = isMobileViewPort
    ? 'Enter manager PIN to clear all orders. Once cleared, the orders can not be recovered.'
    : 'Enter manager PIN to clear all orders.\nOnce cleared, the orders can not be\n recovered.'

  if (showClearOrdersModal) {
    clearOrdersModal = (
      <ConfirmModalV2
        onButtonOneClick={() => {
          setShowClearOrdersModal(false)
        }}
        onButtonTwoClick={() => {
          onClickClearOrders()
          setShowClearOrdersModal(false)
        }}
        headerText={'Clear Orders?'}
        subtext={clearOrdersSubtext}
        buttonOneText={'NO, NEVER MIND'}
        buttonTwoText={'YES, CLEAR'}
      />
    )
  }

  const registerDeviceSubtext = isMobileViewPort
    ? 'Enter manager PIN to reset device and reregister in a new ecosystem, org or venue. Once reset, this action cannot be undone.'
    : 'Enter manager PIN to reset device and reregister in a new ecosystem, org or venue.\nOnce reset, this action cannot be undone.'

  const getOpenCashDrawerButton = () => {
    if (cashEnabled) {
      return (
        <Button className={styles.openCashDrawerButton} onClick={onClickOpenCashDrawer}>
          Open Cash Drawer
        </Button>
      )
    }
    return null
  }

  return (
    <div className={styles.debugInfoContainer}>
      <div id="externalContent" className={styles.externalModal}>
        <div className={styles.externalModalContent}>
          <div className={styles.externalHeader}>
            <span className={styles.externalClose} onClick={onClickExternalClose}>
              &times;
            </span>
          </div>
          <iframe id="externalWebsite" src="" className={styles.externalWebsite}></iframe>
        </div>
      </div>

      <VNConcessionsNavBar textDisplay={menu.name} onClick={() => {}} useHamburgerIcon={true} useSmallTitleFont={true} />
      {clearOrdersModal}

      <div className={styles.selectorContainer}>
        <SegmentedControlV2 items={options} selectedValue={toggle} onSelect={onChange} />
      </div>

      {/* Hardware View */}
      {toggle === DEBUG_TABS.HARDWARE && (
        <div className={classNames}>
          <div className={styles.row}>
            <div className={styles.columnOne}>
              <div className={styles.categoryHeader}>Device</div>

              <div className={styles.category}>Device ID</div>
              <p className={styles.categoryInfo}>{isSummit ? serialNumber : deviceId}</p>

              <div className={styles.category}>Secondary Device ID</div>
              <p className={styles.categoryInfo}>{secondaryDeviceId || 'unknown'}</p>

              <div className={styles.category}>Device Screen Size</div>
              <p className={styles.categoryInfo}>{screenSize}</p>
              {getOpenCashDrawerButton()}
            </div>

            <div className={styles.columnTwo}>
              <div className={styles.categoryHeader}>Card Reader</div>
              {deviceType === PAX_PAYMENT_TYPE && (
                <>
                  <div className={styles.category}>Payment Processing Mode</div>
                  <div className={styles.offline}>
                    <Box className={styles.safBox}>
                      <Typography className={styles.onlineFirst}>Online First</Typography>
                      <VNBlueSwitch checked={safMode === 2} onChange={handleOnSafToggle} />
                      <Typography className={styles.offlineOnly}>Offline Only</Typography>
                    </Box>
                  </div>

                  <div>
                    <Typography className={styles.safModeInfo}>
                      {safMode === 2
                        ? 'All payments will be taken offline and processed once back online.'
                        : 'Payments will be processed online when possible.'}
                    </Typography>
                  </div>
                </>
              )}

              <div className={styles.category}>Store ID </div>
              <p className={styles.categoryInfo}>{storeId}</p>
              <div className={styles.category}>Terminal ID</div>
              <p className={styles.categoryInfo}>{terminalId}</p>
              <div className={styles.category}>ES Key</div>
              <p className={styles.categoryInfo}>{esKey}</p>
              <div className={styles.category}>Service URL</div>
              <p className={styles.categoryInfo}>{serviceURL}</p>

              {deviceType === 'pax' && <div className={styles.category}>Full Card Reader Response</div>}
              {deviceType === 'pax' && <p className={styles.categoryInfo}>{JSON.stringify(safFullResponse, null, 2)}</p>}
            </div>
          </div>
        </div>
      )}

      {/* Software View */}
      {toggle === DEBUG_TABS.SOFTWARE && (
        <div className={classNames}>
          <div className={styles.row}>
            <div className={styles.columnOne}>
              <div className={styles.categoryHeader}>Software</div>
              <div className={styles.category}>Organization</div>
              <p className={styles.categoryInfo}>{process.env.REACT_APP_ORG || 'unknown'}</p>

              <div className={styles.category}>App Version</div>
              <p className={styles.categoryInfo}>{process.env.REACT_APP_VERSION || 'unknown'}</p>

              <div className={styles.category}>App Build Info</div>
              <p className={styles.categoryInfo}>{buildInfo || 'unknown'}</p>

              <div className={styles.category}>Websocket Info</div>
              <p className={styles.websocketInfo}>{JSON.stringify(websocketInfo) || 'unknown'}</p>

              <div className={styles.category}>Clear Local Order Data</div>
              <Button className={styles.clearOrdersButton} onClick={() => setShowClearOrdersModal(true)}>
                Clear All Orders
              </Button>
            </div>

            <div className={styles.columnTwo}>
              <div>
                <div className={styles.categoryHeader}>Access Token</div>
                <div className={styles.category}>Subject</div>
                <p className={styles.categoryInfo}>{tokenPayload.sub}</p>

                <div className={styles.category}>Expiration Time</div>
                <p className={styles.categoryInfo}>{moment.unix(tokenPayload.exp).toString()}</p>

                <div className={styles.category}>Token ID (JTI)</div>
                <p className={styles.categoryInfo}>{tokenPayload.jti}</p>

                <div className={styles.category}>Audience</div>
                <p className={styles.categoryInfo}>{tokenHeader.aud}</p>

                <div className={styles.category}>Latest Error</div>
                <p className={styles.categoryInfo}>{JSON.stringify(errorInfo)}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Network View */}
      {toggle === DEBUG_TABS.NETWORK && (
        <div className={classNames}>
          <div className={styles.row}>
            <div className={styles.columnOne}>
              <div className={styles.categoryHeader}>Performance Information</div>
              <div className={styles.category}>Signal Strength</div>
              <p className={styles.categoryInfo}>Signal strength is a measure of your connection to your network access point.</p>

              <div className={styles.categoryHeader}>Performance</div>

              <div className={styles.category}>Signal Strength</div>
              <p className={styles.categoryInfo}>{signalSpeedDisplay}</p>

              <div className={styles.category}>Internet Speed Test</div>
              <div className={styles.speedTestClickable} onClick={onClickSpeedTest}>
                Fast.com
              </div>
              <p className={styles.categoryInfo}>10 Mbps download and 5 Mbps upload recommended</p>
            </div>

            <div className={styles.columnTwo}>
              <div className={styles.categoryHeader}>Allow List Information</div>
              <div className={styles.category}>UNKNOWN</div>
              <p className={styles.categoryInfo}>Indicates waiting for a response.</p>
              <div className={styles.category}>SUCCESS</div>
              <p className={styles.categoryInfo}>Indicates the url is reachable within a reasonable time limit</p>
              <div className={styles.category}>FAILED</div>
              <p className={styles.categoryInfo}>Indicates the url is unreachable within a reasonable time limit.</p>

              <div className={styles.categoryHeader}>Allow List</div>
              {networkAllowListComponent}
            </div>
          </div>
        </div>
      )}

      {/* TODO(mkramerl): Break these out into their own components. */}
      {/* Printing View */}
      {toggle === DEBUG_TABS.PRINTING && (
        <div className={classNames}>
          <div className={styles.row}>
            <div className={styles.columnOne}>
              <div className={styles.categoryHeader}>Websocket Information</div>

              <div className={styles.category}>Websocket Connection</div>
              <p className={styles.categoryInfo}>{webSocketStatus}</p>

              <div className={styles.category}>Last Websocket Connection</div>
              <p className={styles.categoryInfo}>{webSocketConnectionTime}</p>

              {/* This is for later. The pusher URI won't embed properly. */}
              {/* <div className={styles.category}>Pusher Test</div>
                <div className={styles.speedTestClickable} onClick={onClickPusherTest}>Pusher Test Site</div> */}
            </div>

            <div className={styles.columnTwo}>
              <div className={styles.categoryHeader}>Network Printers</div>
              {printerListComponent}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  const presetToggle = get(ownProps, 'match.params.presetToggle', DEBUG_TABS.HARDWARE)

  const config = getCurrentConfiguration(state)?.configuration || {}
  const buildInfo = getBuildInfo(state, { json: false })
  const secondaryDeviceId = getTerminalInfo(state).serialNumber
  const deviceType = getPaymentType(state)
  const errorInfo = getErrorInfo(state)
  const safFullResponse = getSafFullResponse(state)

  return { presetToggle, config, buildInfo, secondaryDeviceId, deviceType, errorInfo, safFullResponse }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadPrinters: () => {
      dispatch(fetchPrinters())
    },
    onBuildInfoReceived: (payload) => dispatch(onBuildInfoReceived(payload)),
    onClickClearAllOrders: () => dispatch(purgeAllOrders()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DebugInfo)
